var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.939 16.97c0 9.372-7.597 16.969-16.97 16.969C7.598 33.939 0 26.342 0 16.969 0 7.598 7.597 0 16.97 0c9.372 0 16.969 7.597 16.969 16.97ZM20.426 9.623h1.728c.475 0 .864-.389.864-.864V6.168a.867.867 0 0 0-.864-.865h-2.592a5.189 5.189 0 0 0-5.185 5.184v4.322h-2.592a.867.867 0 0 0-.865.864v2.593c0 .475.39.864.865.864h2.592v9.506H18.7V19.13h2.748c.416 0 .77-.294.847-.692l.518-2.592a.869.869 0 0 0-.847-1.037H18.7v-3.457c0-.95.778-1.728 1.727-1.728Z",
    fill: "#2C112D"
  })));
};
export default SvgFacebook;